import { paths } from '@/config/paths';
import { Link } from 'react-router-dom';

export default function Unauthorized() {
  return (
    <div className="max-w-2xl m-auto mt-16">
      <div className="text-center px-4">
        <div className="inline-flex mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-t from-red-200 to-red-100 dark:from-red-700 dark:to-red-800 mb-4">
            <svg className="w-5 h-6 fill-current" viewBox="0 0 20 24">
              <path
                className="text-red-500 dark:text-red-600"
                d="M10 10.562l9-5-8.514-4.73a1 1 0 00-.972 0L1 5.562l9 5z"
              />
              <path
                className="text-red-300 dark:text-red-400"
                d="M9 12.294l-9-5v10.412a1 1 0 00.514.874L9 23.294v-11z"
              />
              <path
                className="text-red-400 dark:text-red-500"
                d="M11 12.294v11l8.486-4.714a1 1 0 00.514-.874V7.295l-9 4.999z"
              />
            </svg>
          </div>
        </div>
        <div className="mb-6">
          Du har inte behörighet att se denna sida. Testa att{' '}
          <Link to={paths.user.memberships.getHref()} className="underline">
            byta gruppvy.
          </Link>
        </div>
        <Link
          to="/login"
          className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
        >
          Till inloggningssidan
        </Link>
      </div>
    </div>
  );
}
